import { render, staticRenderFns } from "./DashboardQuickLearn.vue?vue&type=template&id=077942de&scoped=true&"
import script from "./DashboardQuickLearn.vue?vue&type=script&lang=js&"
export * from "./DashboardQuickLearn.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQuickLearn.vue?vue&type=style&index=0&id=077942de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077942de",
  null
  
)

export default component.exports